export default function formatPhone(phone) {
  return phone
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d{4,5})(\d{4})$/, '($1) $2-$3');
}
